import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WhiteLabelPage } from '@/features/branding/white-label-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Marque blanche du locataire (F9.11) — `GET /style`, `PATCH /style` (`/tenant/admin`). */
export const Route = createFileRoute('/$tenant/branding')({ component: BrandingRoute });

function BrandingRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="branding" crumbs={[{ label: t('branding.title') }]}>
      <WhiteLabelPage tenantId={tenant} />
    </ConsoleShell>
  );
}
